export const REPORTS = "/reports";
export const SUMMARY_REPORT = "/summary_reports";
